// extracted by mini-css-extract-plugin
export var brand = "_1s-9";
export var compact = "_1s-6";
export var extraSmall = "_1s-7";
export var icon = "_1s-0";
export var large = "_1s-4";
export var light = "_1s-1";
export var medium = "_1s-5";
export var outline = "_1s-b";
export var primaryDark = "_1s-a";
export var primaryLight = "_1s-8";
export var primaryModern = "_1s-c";
export var success = "_1s-2";
export var successSolid = "_1s-3";